import { render, staticRenderFns } from "./EnterSuccess.vue?vue&type=template&id=31cdbd69&scoped=true&"
import script from "./EnterSuccess.vue?vue&type=script&lang=ts&"
export * from "./EnterSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./EnterSuccess.vue?vue&type=style&index=0&id=31cdbd69&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cdbd69",
  null
  
)

export default component.exports